export const NO_VALUE = '—';
export const RIGHT_ARROW = '→';
